declare var $: any;

export class IntegerInput {
    static init() {
        $(document).on("click", ".js-increase", IntegerInput.increase);
        $(document).on("click", ".js-decrease", IntegerInput.decrease);
        $(document).on("change", ".integer-input-value", IntegerInput.change);
        IntegerInput.bindEvents();
    }

    static bindEvents() {
        $(".integer-input-value").each((index: Number, textBox: any) => {
            IntegerInput.toggleInputs($(textBox), false);
        });
    }

    static increase(e: Event) {
        const $textBox = $(this).siblings(".integer-input-value");
        const value = Number($textBox.val());
        const maxValue = Number($textBox.data("max-value"));
        if (value < maxValue) $textBox.val(value + 1);
        IntegerInput.toggleInputs($textBox);
    }

    static decrease(e: Event) {
        const $textBox = $(this).siblings(".integer-input-value");
        const value = Number($textBox.val());
        const minValue = Number($textBox.data("min-value"));
        if (value > minValue) $textBox.val(value - 1);
        IntegerInput.toggleInputs($textBox);
    }

    static change() {
        IntegerInput.toggleInputs($(this));
    }

    static toggleInputs($textBox: any, triggerUpdated: boolean = true) {
        const $inc = $textBox.siblings(".js-increase");
        const $dec = $textBox.siblings(".js-decrease");

        const value = Number($textBox.val());
        const minValue = Number($textBox.data("min-value"));
        const maxValue = Number($textBox.data("max-value"));

        if (value >= maxValue) {
            $inc.attr("disabled", true);
            $textBox.val(maxValue);
        } else {
            $inc.attr("disabled", false);
        }

        if (value <= minValue) {
            $dec.attr("disabled", true);
            $textBox.val(minValue);
        } else {
            $dec.attr("disabled", false);
        }

        if (triggerUpdated) {
            $textBox.trigger("updated");
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/integerInput.ts